import { EmailTemplateResponse } from '../../generated'

// The custom template editor is deliberately unadvertised: only clubs that already
// use it (toggle on) or already drafted one (json saved) get to see it.
export const hasCustomTemplate = (
  template: EmailTemplateResponse | undefined
): boolean => Boolean(template && (template.customTemplateOn || template.json))
